import * as requestFromServer from "./cityCrud";
import {citySlice, callTypes} from "./citySlice";

const {actions} = citySlice;

export const listCity=queryParams=>dispatch => {
  console.log('I am callled');
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .listCity(queryParams)
    .then(response => {
      console.log('city',response)
      const { totalCount, entities,data } = response;
      dispatch(actions.cityFetched({ totalCount, entities,data }));
    })
    .catch(error => {
      console.log('Iam inside error',error);
      error.clientMessage = "Can't find City";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const createCity=city=>dispatch => {
  console.log('hecity',city);
    dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer.createCity(city)
  
      .then(response => {
        console.log("i am city",response);
        const {data } = response.data;
        const totalCount=data.length;
              console.log('I am testing',data,totalCount);
         dispatch(actions.cityCreated({entities:data,totalCount}));
      })
      .catch(error => {
        console.log('Iam inside error',error);
        error.clientMessage = "Can't find Country";
        dispatch(actions.catchError({ error, callType: callTypes.list }));
      });
  };